<div class="z-contenedor">
  <router-outlet></router-outlet>
</div>